export default __webpack_public_path__ + "static/media/logo-gray.0bf21346.svg";